module.exports = __webpack_public_path__ + "media/application/images/svgs/carousel-chevron-right-48b2ead24f5c38d5f1bbfbc261d29700.svg";